import { useMemo } from 'react';
import type { ColumnDef } from '@deckspace/types';
import { useSurfaceContext } from '../../components/surface/SurfaceContext';
import { Kanban } from './index.js';
import type { KanbanMapping } from './utils.js';

interface KanbanViewProps {
  nodeId: string;
  mapping: {
    card: string;
    column: string;
    subtitle?: string;
  };
  minimized?: boolean;
  // Injected by withDataset HOC (Task 8):
  rows: Record<string, unknown>[];
  columnDefs: ColumnDef[];
}

const EMPTY_CONFIG = {};

export function KanbanView({ mapping, rows, columnDefs }: KanbanViewProps) {
  const { themeKey } = useSurfaceContext();

  // Use primitive deps (not mapping object ref) to avoid new ref on every parent render
  const kanbanMapping = useMemo<KanbanMapping>(
    () => ({
      card: mapping.card,
      column: mapping.column,
      subtitle: mapping.subtitle,
    }),
    [mapping.card, mapping.column, mapping.subtitle]
  );

  return (
    <Kanban
      key={themeKey}
      rows={rows}
      columnDefs={columnDefs}
      mapping={kanbanMapping}
      config={EMPTY_CONFIG}
    />
  );
}
